import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"max-content !important"} }

import { ref, Ref, onMounted } from 'vue';
import { useStore }     from 'vuex';
import axios            from 'axios';

// CONSTANTS
import CONSTAPIS        from '@/constants/apis';

// INTERFACES
import { STRINGS }      from '@/interfaces/SmartLink/General';
import { TOKEN } from '@/constants/labels';


export default /*#__PURE__*/_defineComponent({
  __name: 'DBmaintenance',
  setup(__props) {

const store             = useStore();

const color:Ref<STRINGS>         = ref({
    cambium_data        : 'red',
    eventos             : 'red',
    latencia            : 'red',
    LTE_data            : 'red',
    predicciones        : 'red',
    rajant_data         : 'red',
    sensores            : 'red',
    servidor_data       : 'red',
    ubicacion_gps       : 'red',
});

/**
 * Array con todas las tablas seleccionadas para eliminar los datos
 * anteriores al datePickVal. Es usada en los checkboxes
 */
const dbSelected        = ref([]);

/**
 * Valor maximo del datepicker, inicializa en el primer día del mes anterior.
 * Ese valor se realiza luego del "OnMounted" -> "getMaxDate()"
 */
const dateMax           = ref('');

/**
 * Valor de la fecha seleccionada del datepicker, por defecto es el "dateMax"
 */
const datePickVal       = ref(new Date());

/**
 * Valor del tiempo seleccionado, para el título.
 */
const timeSelected      = ref('');


/**
 * Captura una fecha y regresa el formato final para la DB
 * @param date 
 */
const changeDate = async (date:Date) => {
    let getFinalDay      = date.getDate().toString().length === 1 ? `0${date.getDate()}` : `${date.getDate()}` ;
    let getFinalMonth    = (date.getMonth() + 1).toString().length === 1 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
    let getFinalYear     = date.getFullYear();
    
    timeSelected.value = `${getFinalYear}-${getFinalMonth}-${getFinalDay} 00:00:00`
}


/**
 * Captura el primer dia del mes anterior.
 * EJM: 
 *  NOW() : 03/04/2025
 *  DATE(): 01/03/2025
 */
const getMaxDate = async() => {
    let dateNow         = new Date();
    
    let getPrevMonth    = dateNow.getMonth() === 0 ? `12` : `${dateNow.getMonth()}`;
    let getFinalMonth   = getPrevMonth.length === 1 ? `0${getPrevMonth}` : `${getPrevMonth}`;
    let getFinalYear    = dateNow.getMonth() === 0 ? dateNow.getFullYear() - 1 : dateNow.getFullYear();
    
    dateMax.value       = `${getFinalYear}-${getFinalMonth}-01 00:00:00`;
    datePickVal.value   = new Date(dateMax.value)
}

/**
 * Realiza la eliminación de las tablas seleccionadas.
 */
const CleanDB = () => {

    /**
     * Del array de tablas seleccionadas, cada una envía una petición de eliminación
     */
    dbSelected.value.forEach((dbSel:string) => {

        let param = {
            table   : dbSel,
            time    : timeSelected.value, 
        }

        axios.delete(CONSTAPIS.APIS.value.general.deleteDataInDB,{params:param, headers: { "Authorization": `Bearer ${TOKEN}`}}).then((result) =>{
            if(!result.data.error){
                let database            = result.data.body;
                color.value[database]   = 'green';
                store.dispatch('showSnackBar', {type: 'setSnackDelete', msg: `datos eliminados`});
            }
        })
    })
}

onMounted(async ()=>{
    await getMaxDate();
    await changeDate(new Date(dateMax.value));
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_speed_dial = _resolveComponent("v-speed-dial")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    color: "bgtopology",
    class: "defaultCard"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_speed_dial, {
        location: "top center",
        transition: "slide-x-transition",
        "close-on-content-click": false
      }, {
        activator: _withCtx(({ props: activatorProps }) => [
          _createVNode(_component_v_row, {
            class: "ma-2",
            justify: "start"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, _mergeProps({
                color: "bgDashCard",
                size: "small",
                class: "mr-4"
              }, activatorProps), {
                default: _withCtx(() => [
                  _createTextVNode(" Selecciona Fecha ")
                ]),
                _: 2
              }, 1040),
              _createElementVNode("h4", _hoisted_1, " Se eliminaran datos anteriores a: " + _toDisplayString(timeSelected.value), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_date_picker, {
            key: "1",
            color: "primary",
            max: dateMax.value,
            modelValue: datePickVal.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((datePickVal).value = $event)),
              _cache[1] || (_cache[1] = ($event: any) => (changeDate(datePickVal.value)))
            ],
            "show-adjacent-months": ""
          }, null, 8, ["max", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dbSelected).value = $event)),
                label: "Cambium Data",
                value: "cambium_data",
                color: color.value['cambium_data'],
                readonly: color.value['cambium_data'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dbSelected).value = $event)),
                label: "eventos",
                value: "eventos",
                color: color.value['eventos'],
                readonly: color.value['eventos'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dbSelected).value = $event)),
                label: "latencia",
                value: "latencia",
                color: color.value['latencia'],
                readonly: color.value['latencia'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dbSelected).value = $event)),
                label: "LTE Data",
                value: "LTE_data",
                color: color.value['LTE_data'],
                readonly: color.value['LTE_data'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dbSelected).value = $event)),
                label: "predicciones",
                value: "predicciones",
                color: color.value['predicciones'],
                readonly: color.value['predicciones'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dbSelected).value = $event)),
                label: "Rajant Data",
                value: "rajant_data",
                color: color.value['rajant_data'],
                readonly: color.value['rajant_data'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dbSelected).value = $event)),
                label: "sensores",
                value: "sensores",
                color: color.value['sensores'],
                readonly: color.value['sensores'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dbSelected).value = $event)),
                label: "Servidor Data",
                value: "servidor_data",
                color: color.value['servidor_data'],
                readonly: color.value['servidor_data'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            sm: "6",
            md: "4",
            lg: "3",
            xl: "2",
            xxl: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: dbSelected.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dbSelected).value = $event)),
                label: "Ubicación GPS",
                value: "ubicacion_gps",
                color: color.value['ubicacion_gps'],
                readonly: color.value['ubicacion_gps'] === 'green'
              }, null, 8, ["modelValue", "color", "readonly"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        color: "btnSelect",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (CleanDB())),
        class: "mt-5",
        disabled: !(dbSelected.value.length > 0)
      }, {
        default: _withCtx(() => [
          _createTextVNode(" limpiar ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }))
}
}

})